function createLinkElement(href) {
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', href);
    return link;
}

function loadStyle(staticUrl = '/id/static/', realm = 'ru') {
    const customsStyles = {
        cn: 'wgni-cn',
        lg: 'wgni-navy',
        lst: 'lsti',
    };
    const styleFile = customsStyles[realm] ?? 'wgni';
    const allLinks = [
        `${staticUrl}wgnet/css/${styleFile}.css`,
        `${staticUrl}wgnet/css/override-wgni-lst.css`,
        `${staticUrl}wgnet/css/override-wgni-mobile-lst.css`,
    ];

    const promises = allLinks.map(linkUrl => new Promise(resolve => {
        const linkElement = createLinkElement(linkUrl);
        linkElement.onload = resolve;
        linkElement.onerror = resolve;
        document.head.appendChild(linkElement);
    }));

    return Promise.all(promises);
}

export default loadStyle;
